import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { asRoundedPercentage } from "@components/Filters/number.js";
import { DomainDesignation } from "@constants";
export default {
  filters: {
    asRoundedPercentage
  },
  props: {
    domain: {
      type: Object,
      default() {
        return {};
      }
    },
    facts: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      designation: {}
    };
  },
  mounted() {
    this.setTheme();
  },
  computed: {
    pointsEarned() {
      let pointsEarned = 0;
      for (let i = 0; i < this.scoredFacts.length; i++) {
        pointsEarned += this.scoredFacts[i].IndicatorPointsEarned;
      }
      return pointsEarned;
    },
    pointsPossible() {
      let pointsPossible = 0;
      for (let i = 0; i < this.scoredFacts.length; i++) {
        pointsPossible += this.domain.Indicators.find(x => this.scoredFacts[i].DomainIndicatorId === x.DomainIndicatorId).PointsPossible;
      }
      return pointsPossible;
    },
    scoredFacts() {
      return DomainDesignation.getScoredFacts(this.facts);
    }
  },
  watch: {
    facts() {
      this.setTheme();
    }
  },
  methods: {
    setTheme() {
      this.designation = DomainDesignation.getDesignation(this.facts, this.domain);
    }
  }
};